import { AxiosResponse } from 'axios';
import axios from '@/_utils/axios';
import { FocusVersionScheduling, PolarisApiResponse } from '@/redux/slices/slice_types';

export const updateSchedule = (id: number, schedule: Partial<FocusVersionScheduling>) => {
  return (
    axios
      // TODO: this end-point doesn't exist yet. When we have it please validate request payload is correct and remove this comment
      .post<PolarisApiResponse<FocusVersionScheduling>, AxiosResponse<PolarisApiResponse<FocusVersionScheduling>>, Partial<FocusVersionScheduling>>(
        `/focus/scheduling/${id}/`,
        schedule,
        { baseURL: '/api/v1.1' }
      )
  );
};
